import LcChopApproved from "./LcChopApproved";

export { LcChopApproved };
export default LcChopApproved;
